module.exports = __webpack_public_path__ + "img/about-us.a585df44.png";